import { motion } from "framer-motion";

const links = [
  { label: "Manifesto", href: "manifesto" },
  { label: "Membership", href: "membership" },
  { label: "Gifting", href: "gift" },
];

export const Header = ({ member }) => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-ink/10 bg-paper/80 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 md:px-12">
        <button
          data-testid="header-logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
        >
          <img src="/assets/logo.png" alt="Unlabeled Wine Club" className="aspect-square h-10 w-10 rounded-full object-cover mix-blend-multiply" />
          <span className="font-serif text-lg tracking-tight">Unlabeled</span>
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href}-link`}
              onClick={() => go(l.href)}
              className="text-sm text-ink/70 transition-colors duration-300 hover:text-wine"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          {member && (
            <span data-testid="header-member-badge" className="hidden text-xs uppercase tracking-widest text-ink/50 sm:block">
              {member.tier === "premium" ? "Premium member" : "Member"}
            </span>
          )}
          <button
            data-testid="header-join-button"
            onClick={() => go("join")}
            className="rounded-full bg-wine px-5 py-2 text-sm text-paper transition-colors duration-300 hover:bg-ink"
          >
            Join free
          </button>
        </div>
      </div>
    </motion.header>
  );
};
